import { lastDays, PERIOD_PRESETS, periodDays, periodProblem, type Period } from './period.ts';

/**
 * Report period (BB-123, BB-79): quick «last 7 / 30 / 90 days» and exact dates. An invalid range is shown, not sent:
 * reports keep the last valid answer until the dates are fixed.
 */
export function PeriodPicker({ value, onChange, end }: { value: Period; onChange: (period: Period) => void; end?: string }) {
  const problem = periodProblem(value);
  const days = periodDays(value);
  const preset = (n: number) => lastDays(n, end);
  return (
    <fieldset className="period-picker">
      <legend>Period</legend>
      {PERIOD_PRESETS.map((n) => {
        const p = preset(n);
        const active = p.from === value.from && p.to === value.to;
        return (
          <button key={n} type="button" className={active ? 'button button--active' : 'button'} aria-pressed={active} onClick={() => onChange(p)}>
            Last {n} days
          </button>
        );
      })}
      <label>
        From <input type="date" value={value.from} max={value.to || undefined} onChange={(e) => onChange({ ...value, from: e.target.value })} />
      </label>
      <label>
        To <input type="date" value={value.to} min={value.from || undefined} onChange={(e) => onChange({ ...value, to: e.target.value })} />
      </label>
      {problem ? (
        <span role="alert" className="field-error">
          {problem}
        </span>
      ) : (
        <span className="hint">{days === 1 ? '1 day' : `${days} days`}</span>
      )}
    </fieldset>
  );
}
